import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  getCelularesAppExpedicao,
  getUsuariosAssocCelularAppExpedicao,
  salvarCelularAppExpedicao,
  toggleUsuarioAutorizado,
  toggleUsuarioFinalizaPicking,
  toggleUsuarioConfiguraPicking,
  toggleUsuarioConfiguraReconferenciaEtiqueta,
  getCelularesAppExpedicaoByEmail,
  getUsuariosByCelularesAppExpedicao,
  salvarAssociacaoMassaConfigsAppExpedicao,
} from '../../../../services/api/https/system/system.http'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import {
  Btn,
  CustomCheckbox,
  CustomDropdownWithFilter,
  CustomModal,
  CustomPanel,
  DateTime,
  InputDate,
  InputText,
  Loading,
  PageHeader,
  ThreeDots,
  CustomDataTable,
  CustomDataTableHeader,
} from '../../../../components'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import * as colors from '../../../../assets/js/colors'
import { Fieldset } from 'primereact/fieldset'

function CelularAppExpedicao({ history, dispatch, selectedTp }) {
  // Vars
  const novoCelular = {
    codigo_ativacao: '',
    ativado: 0,
    data_ativacao: '',
    habilitado: 1,
    tp_id: selectedTp,
  }

  // Hooks
  const [celulares, setCelulares] = useState([])
  const [showCelularModal, setShowCelularModal] = useState(false)
  const [showUsuarioModal, setShowUsuarioModal] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [selectedCelular, setSelectedCelular] = useState(novoCelular)
  const [emailUsuario, setEmailUsuario] = useState('')
  const [selectedCelulares, setSelectedCelulares] = useState([])
  const [showAssociacaoAutomaticaModal, setShowAssociacaoAutomaticaModal] = useState(false)

  // Events
  const onBtnNovo = () => {
    setSelectedCelular(novoCelular)
    setShowCelularModal(true)
  }
  const onBtnVoltar = () => {
    history.goBack()
  }
  const onModalCelularClose = () => {
    setShowCelularModal(false)
  }
  const onModalCelularSuccess = celular => {
    const index = celulares.findIndex(c => c.id === celular.id)
    if (index === -1) {
      setCelulares([celular, ...celulares])
    } else {
      const newCelulares = [...celulares]
      newCelulares[index] = celular
      setCelulares(newCelulares)
    }
    setShowCelularModal(false)
    dispatch(showMessageBox('Operação realizada com sucesso', null))
  }

  const onModalCelularError = error => {
    dispatch(showMessageBox(null, errorHandler(error)))
  }

  const onModalUsuarioClose = () => {
    setShowUsuarioModal(false)
  }

  const onModalUsuarioError = error => {
    dispatch(showMessageBox(null, errorHandler(error)))
    setShowUsuarioModal(false)
  }

  const onBtnAssociacaoAutomatica = () => {
    if (!selectedCelulares.length) {
      dispatch(
        showMessageBox(null, 'Selecione ao menos um código para aplicar as permissões automáticas')
      )
      return
    }
    setShowAssociacaoAutomaticaModal(true)
  }

  const onModalAssociacaoAutomaticaClose = () => {
    setShowAssociacaoAutomaticaModal(false)
  }

  const onModalAssociacaoAutomaticaSuccess = registros_atualizados => {
    setShowAssociacaoAutomaticaModal(false)
    setSelectedCelulares([])
    dispatch(
      showMessageBox(
        `Operação realizada com sucesso. ${registros_atualizados} associação(ões) atualizada(s)`,
        null
      )
    )
  }

  const onModalAssociacaoAutomaticaError = error => {
    dispatch(showMessageBox(null, errorHandler(error)))
  }

  const onMenuItemClick = (menuItem, celular) => {
    setSelectedCelular(celular)
    switch (menuItem) {
      case 'Editar':
        setShowCelularModal(true)
        break
      case 'Usuários':
        setShowUsuarioModal(true)
        break
      default:
        break
    }
  }

  // Hooks
  useEffect(() => {
    _getCelulares()
  }, [selectedTp])

  // Helpers
  const _getCelulares = async () => {
    try {
      const celulares = await getCelularesAppExpedicao(selectedTp)
      setCelulares(celulares)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    } finally {
      setIsLoading(false)
    }
  }

  const _getCelularesByEmail = async () => {
    if (!emailUsuario) {
      dispatch(showMessageBox(null, 'Informe o email do usuário para buscar os celulares'))
      return
    }
    try {
      const celulares = await getCelularesAppExpedicaoByEmail(selectedTp, emailUsuario)
      setCelulares(celulares)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  return (
    <div>
      <PageHeader>
        S.11 - Celulares -&nbsp;<strong>Aplicativo Expedição</strong>&nbsp;- Por TP
      </PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={onBtnNovo} onVoltar={onBtnVoltar}>
          {isLoading ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <CelularesDataTable
              celulares={celulares}
              selectedTp={selectedTp}
              onMenuItemClick={onMenuItemClick}
              emailUsuario={emailUsuario}
              onEmailChange={setEmailUsuario}
              onBuscarClick={_getCelularesByEmail}
              selectedCelulares={selectedCelulares}
              onSelectionChange={setSelectedCelulares}
              onPermissoesAutomaticasClick={onBtnAssociacaoAutomatica}
            />
          )}
        </CustomPanel>
      </div>
      {showCelularModal ? (
        <CelularModal
          celular={selectedCelular}
          onModalClose={onModalCelularClose}
          onModalSuccess={onModalCelularSuccess}
          onModalError={onModalCelularError}
        />
      ) : null}
      {showUsuarioModal ? (
        <UsuariosModal
          celular_id={selectedCelular.id}
          onModalUsuarioClose={onModalUsuarioClose}
          onModalUsuarioError={onModalUsuarioError}
        />
      ) : null}
      {showAssociacaoAutomaticaModal ? (
        <AssociacaoAutomaticaModal
          celularIds={selectedCelulares.map(c => c.id)}
          onModalClose={onModalAssociacaoAutomaticaClose}
          onModalSuccess={onModalAssociacaoAutomaticaSuccess}
          onModalError={onModalAssociacaoAutomaticaError}
        />
      ) : null}
    </div>
  )
}

function CelularesDataTable({
  celulares,
  selectedTp,
  onMenuItemClick,
  emailUsuario,
  onEmailChange,
  onBuscarClick,
  selectedCelulares,
  onSelectionChange,
  onPermissoesAutomaticasClick,
}) {
  const [globalFilter, setGlobalFilter] = useState('')

  return (
    <>
      <Fieldset legend="Filtro" toggleable collapsed={true} className="p-col-12 p-mb-3">
        <div className="p-grid p-align-center">
          <div className="p-col-4">
            <InputText label="Email do Usuário" value={emailUsuario} onChange={onEmailChange} />
          </div>
          <div className="p-col-2" style={{ marginTop: 32 }}>
            <Btn
              onClick={onBuscarClick}
              disabled={!selectedTp}
              title={!selectedTp ? 'Selecione um TP para buscar' : undefined}
            >
              Buscar
            </Btn>
          </div>
        </div>
      </Fieldset>
      <div style={{ marginBottom: 10 }}>
        <Btn onClick={onPermissoesAutomaticasClick} disabled={!selectedCelulares.length}>
          Permissões Automáticas
        </Btn>
      </div>
      <CustomDataTable
        emptyMessage="Não existem códigos de ativação gerados"
        value={celulares}
        paginator
        rows={20}
        globalFilter={globalFilter}
        header={<CustomDataTableHeader onChange={setGlobalFilter} />}
        dataKey="id"
        selection={selectedCelulares}
        onSelectionChange={e => onSelectionChange(e.value)}
      >
        <Column selectionMode="multiple" style={{ width: '3em' }} />
        <Column field="id" header="Código" style={tableCellCentered(80)} />
        <Column field="codigo_ativacao" header="Código de Ativação" />
        <Column
          field="ativado"
          header="Ativado"
          style={tableCellCentered()}
          body={celular => <CustomCheckbox disabled={true} checked={celular.ativado === 1} />}
        />
        <Column
          field="data_ativacao"
          header="Data da Ativação"
          style={tableCellCentered(150)}
          body={celular =>
            celular.data_ativacao ? <DateTime>{celular.data_ativacao}</DateTime> : null
          }
        />
        <Column
          field="aplicativo"
          header="Aplicativo"
          style={tableCellCentered(110)}
          body={celular => celular.aplicativo || '-'}
        />
        <Column
          field="versao_app"
          header="Versão"
          style={tableCellCentered(100)}
          body={celular => celular.versao_app || '-'}
        />
        <Column
          field="habilitado"
          header="Habilitado"
          style={tableCellCentered()}
          body={celular => <CustomCheckbox disabled={true} checked={celular.habilitado === 1} />}
        />
        <Column
          field="data_ultima_request"
          header="Última Solicitação"
          style={tableCellCentered()}
          body={celular => <DateTime>{celular.data_ultima_request}</DateTime>}
        />

        <Column
          header="Menu"
          style={tableCellCentered()}
          body={celular => (
            <ThreeDots
              items={['Editar', 'Usuários']}
              onClick={item => onMenuItemClick(item, celular)}
            />
          )}
        />
      </CustomDataTable>
    </>
  )
}

function CelularModal({ celular, onModalClose, onModalSuccess, onModalError }) {
  // Hooks
  const [selectedCelular, setSelectedCelular] = useState(celular)
  const [isLoading, setIsLoading] = useState(false)

  // Events
  const onFormChange = (name, value) => {
    const newState = { ...selectedCelular }
    newState[name] = value
    setSelectedCelular(newState)
  }

  const onModalSalvarClick = async () => {
    try {
      setIsLoading(true)
      const celular = await salvarCelularAppExpedicao({
        ...selectedCelular,
        habilitado: selectedCelular.habilitado ? 1 : 0,
      })
      onModalSuccess(celular)
    } catch (e) {
      setIsLoading(false)
      onModalError(e)
    }
  }
  //Render
  return (
    <CustomModal
      header={celular.id ? 'Editando Celular' : 'Novo Celular'}
      isVisible={true}
      onClose={onModalClose}
    >
      <div className="p-grid">
        <div className="p-col-6">
          <InputText
            marginTop={0}
            label="Código de Ativação"
            value={selectedCelular.codigo_ativacao}
            onChange={value => onFormChange('codigo_ativacao', value.toUpperCase())}
          />
        </div>
        <div className="p-col-6" style={{ paddingTop: 30 }}>
          <CustomCheckbox
            checked={selectedCelular.habilitado === 1}
            onChange={value => onFormChange('habilitado', value)}
          >
            Habilitado
          </CustomCheckbox>
        </div>
      </div>
      <div className="p-grid">
        <div className="p-col-6">
          <InputDate
            marginTop={0}
            disabled={true}
            value={selectedCelular.data_ativacao}
            label="Data de Ativação"
          />
        </div>
        <div className="p-col-6" style={{ paddingTop: 30 }}>
          <CustomCheckbox disabled={true} checked={selectedCelular.ativado === 1}>
            Ativado
          </CustomCheckbox>
        </div>
        <div className="p-col-12">
          <Btn isLoading={isLoading} onClick={onModalSalvarClick}>
            Salvar
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}

function UsuariosModal({ celular_id, onModalUsuarioClose, onModalUsuarioError }) {
  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [isCheckboxLoading, setIsCheckboxLoading] = useState(false)
  const [usuarios, setUsuarios] = useState([])
  const [globalFilter, setGlobalFilter] = useState('')
  useEffect(() => {
    getUsuariosCelular()
  }, [])

  // Events
  const onAutorizadoChange = async usuario => {
    try {
      setIsCheckboxLoading(true)
      await toggleUsuarioAutorizado(usuario.id, usuario.autorizado !== 1)
      const index = usuarios.findIndex(u => u.id === usuario.id)
      if (index !== -1) {
        const newUsuarios = [...usuarios]
        newUsuarios[index].autorizado = usuario.autorizado ? 0 : 1
        setUsuarios(newUsuarios)
      }
      setIsCheckboxLoading(false)
    } catch (e) {
      onModalUsuarioError(e)
    }
  }

  const onFinalizarPickingChange = async usuario => {
    try {
      setIsCheckboxLoading(true)
      await toggleUsuarioFinalizaPicking(usuario.id, usuario.finaliza_picking !== 1)
      const index = usuarios.findIndex(u => u.id === usuario.id)
      if (index !== -1) {
        const newUsuarios = [...usuarios]
        newUsuarios[index].finaliza_picking = usuario.finaliza_picking ? 0 : 1
        setUsuarios(newUsuarios)
      }
      setIsCheckboxLoading(false)
    } catch (e) {
      onModalUsuarioError(e)
    }
  }

  const onConfigurarPickingChange = async usuario => {
    try {
      setIsCheckboxLoading(true)
      await toggleUsuarioConfiguraPicking(usuario.id, usuario.configura_picking !== 1)
      const index = usuarios.findIndex(u => u.id === usuario.id)
      if (index !== -1) {
        const newUsuarios = [...usuarios]
        newUsuarios[index].configura_picking = usuario.configura_picking ? 0 : 1
        setUsuarios(newUsuarios)
      }
    } catch (e) {
      onModalUsuarioError(e)
    } finally {
      setIsCheckboxLoading(false)
    }
  }

  const onConfigurarReconferenciaEtiquetaChange = async usuario => {
    try {
      setIsCheckboxLoading(true)
      await toggleUsuarioConfiguraReconferenciaEtiqueta(
        usuario.id,
        usuario.configura_reconferencia_etiqueta !== 1
      )
      const index = usuarios.findIndex(u => u.id === usuario.id)
      if (index !== -1) {
        const newUsuarios = [...usuarios]
        newUsuarios[index].configura_reconferencia_etiqueta = usuario.configura_reconferencia_etiqueta
          ? 0
          : 1
        setUsuarios(newUsuarios)
      }
    } catch (e) {
      onModalUsuarioError(e)
    } finally {
      setIsCheckboxLoading(false)
    }
  }

  const getUsuariosCelular = async () => {
    try {
      const usuarios = await getUsuariosAssocCelularAppExpedicao(celular_id)
      setUsuarios(usuarios)
      setIsLoading(false)
    } catch (e) {
      onModalUsuarioError(e)
    }
  }

  //Render
  return (
    <CustomModal
      header="Usuários Associados"
      isVisible={true}
      onClose={onModalUsuarioClose}
      width="90vw"
      style={{ maxWidth: '1100px' }}
      contentStyle={{ maxHeight: '80vh', overflowY: 'auto' }}
    >
      {isLoading ? (
        <div className="text-center">
          <Loading />
        </div>
      ) : (
        <CustomDataTable
          value={usuarios}
          emptyMessage="Nenhum Usuário Associado"
          paginator
          rows={15}
          globalFilter={globalFilter}
          header={<CustomDataTableHeader onChange={setGlobalFilter} />}
        >
          <Column field="user_name" header="Usuário" />
          <Column field="user_email" header="E-mail" />
          <Column
            field="autorizado"
            header="Autorizado"
            style={tableCellCentered()}
            body={usuario =>
              isCheckboxLoading ? (
                <Loading size="sm" />
              ) : (
                <CustomCheckbox
                  checked={usuario.autorizado === 1}
                  onChange={() => onAutorizadoChange(usuario)}
                />
              )
            }
          />
          <Column
            field="finaliza_picking"
            header="Finalizar Picking"
            style={tableCellCentered()}
            body={usuario =>
              isCheckboxLoading ? (
                <Loading size="sm" />
              ) : (
                <CustomCheckbox
                  checked={usuario.finaliza_picking === 1}
                  onChange={() => onFinalizarPickingChange(usuario)}
                />
              )
            }
          />
          <Column
            field="configura_picking"
            header="Configurar Picking"
            style={tableCellCentered()}
            body={usuario =>
              isCheckboxLoading ? (
                <Loading size="sm" />
              ) : (
                <CustomCheckbox
                  checked={usuario.configura_picking === 1}
                  onChange={() => onConfigurarPickingChange(usuario)}
                />
              )
            }
          />
          <Column
            field="configura_reconferencia_etiqueta"
            header="Configurar Reconf. de Etiqueta"
            style={tableCellCentered()}
            body={usuario =>
              isCheckboxLoading ? (
                <Loading size="sm" />
              ) : (
                <CustomCheckbox
                  checked={usuario.configura_reconferencia_etiqueta === 1}
                  onChange={() => onConfigurarReconferenciaEtiquetaChange(usuario)}
                />
              )
            }
          />
        </CustomDataTable>
      )}
    </CustomModal>
  )
}

function AssociacaoAutomaticaModal({ celularIds, onModalClose, onModalSuccess, onModalError }) {
  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [isSaving, setIsSaving] = useState(false)
  const [usuarios, setUsuarios] = useState([])
  const [selectedUsuario, setSelectedUsuario] = useState(null)
  const [finalizaPicking, setFinalizaPicking] = useState(false)
  const [configuraPicking, setConfiguraPicking] = useState(false)
  const [configuraReconferenciaEtiqueta, setConfiguraReconferenciaEtiqueta] = useState(false)

  useEffect(() => {
    _getUsuarios()
  }, [])

  // Helpers
  const _getUsuarios = async () => {
    try {
      const usuarios = await getUsuariosByCelularesAppExpedicao(celularIds)
      setUsuarios(usuarios)
    } catch (e) {
      onModalError(e)
      onModalClose()
    } finally {
      setIsLoading(false)
    }
  }

  // Events
  const onSalvarClick = async () => {
    if (!selectedUsuario) {
      onModalError('Selecione o email do usuário')
      return
    }
    try {
      setIsSaving(true)
      const { registros_atualizados } = await salvarAssociacaoMassaConfigsAppExpedicao({
        user_id: selectedUsuario.user_id,
        celular_ids: celularIds,
        finaliza_picking: finalizaPicking,
        configura_picking: configuraPicking,
        configura_reconferencia_etiqueta: configuraReconferenciaEtiqueta,
      })
      onModalSuccess(registros_atualizados)
    } catch (e) {
      setIsSaving(false)
      onModalError(e)
    }
  }

  // Render
  return (
    <CustomModal header="Permissões Automáticas" isVisible={true} onClose={onModalClose}>
      {isLoading ? (
        <div className="text-center">
          <Loading />
        </div>
      ) : (
        <div className="p-grid">
          <div className="p-col-6">
            <CustomDropdownWithFilter
              marginTop={0}
              label="Email do Usuário"
              placeholder={
                usuarios.length
                  ? 'Selecione o email do usuário'
                  : 'Nenhum usuário associado aos códigos selecionados'
              }
              filter={true}
              options={usuarios}
              optionLabel="user_email"
              dataKey="user_id"
              value={selectedUsuario}
              onChange={setSelectedUsuario}
            />
          </div>
          <div className="p-col-12" style={{ marginTop: 15 }}>
            <label style={{ display: 'block', color: colors.azul, fontSize: '0.8rem' }}>
              Permissões para o usuário
            </label>
          </div>
          <div className="p-col-4">
            <CustomCheckbox
              checked={finalizaPicking}
              onChange={value => setFinalizaPicking(value)}
            >
              Finalizar Picking
            </CustomCheckbox>
          </div>
          <div className="p-col-4">
            <CustomCheckbox
              checked={configuraPicking}
              onChange={value => setConfiguraPicking(value)}
            >
              Configurar Picking
            </CustomCheckbox>
          </div>
          <div className="p-col-4">
            <CustomCheckbox
              checked={configuraReconferenciaEtiqueta}
              onChange={value => setConfiguraReconferenciaEtiqueta(value)}
            >
              Configurar Reconf. de Etiqueta
            </CustomCheckbox>
          </div>
          <div
            className="p-col-12"
            style={{ marginTop: 10, color: '#888', fontStyle: 'italic', fontSize: '0.8rem' }}
          >
            Obs: ao salvar, as permissões definidas acima serão aplicadas para o usuário em todos
            os dispositivos selecionados
          </div>
          <div className="p-col-12" style={{ marginTop: 10 }}>
            <Btn isLoading={isSaving} disabled={!selectedUsuario} onClick={onSalvarClick}>
              Salvar
            </Btn>
          </div>
        </div>
      )}
    </CustomModal>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(CelularAppExpedicao))
